// @flow

import React from 'react';
import { LogoImage } from './Logo/styled/LogoImage';
import { LogoWrapper } from './Logo/styled/LogoWrapper';
// import logoSourceSquare from "../../../../assets/images/icon-48x48.png";
import { addSubdirectoryToPath } from '../../../util/getConfig';
import store from '../../../store/store';

export const LittleLogo = () => {
  const { config } = store.getState();
  const { APPLICATION_ASSETS } = config;
  const icon = APPLICATION_ASSETS?.icon || 'icon-48x48.png';
  const path = addSubdirectoryToPath(`/meta/images/${icon}`);

  return (
    <LogoWrapper>
      <LogoImage src={path} style={{ width: '48px', height: '48px', objectFit: 'contain' }} />
    </LogoWrapper>
  );
};

export default LittleLogo;
